export default __webpack_public_path__ + "static/media/logo.93d727f3.png";